import { axiosDevelopment } from './config';

export const VersionHistoryService = {
    GET_FLIMP_VERSIONS(flimpID) {
        return axiosDevelopment.get(`ajax/get-flimp-versions?f=${flimpID}`)
    },
    GET_FLIMP_VERSION(id) {
        return axiosDevelopment.get(`ajax/flimp-versions/${id}`)
    },
    CLONE_FLIMP_VERSION(data) {
        return axiosDevelopment.post('/clone-multimedia-api', data, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
    }
};